import { Flex, FlexProps, Spinner, Text } from '@chakra-ui/react';
import { JobRecord, JobState } from '@texas/api/endpoints/jobRecordsApi';
import { Locale } from '@texas/i18n/types';
import { dateFromNow } from '@texas/utils/helpers/dateHelper';
import { useTranslation } from 'react-i18next';
import { jobTranslations } from './translations';
import { fadeInScaleAnimation } from '@texas/resources/animations/animations';
import {
  compareEnum,
  ensureEnumNumber,
} from '@texas/utils/helpers/enumHelpers';

export function JobItem({ job }: { job: JobRecord }) {
  const { t } = useTranslation();
  const translation = jobTranslations(job, t);

  // Different styles if job is waiting, started and finished
  return (
    <Flex
      p={4}
      gap={4}
      bg="gray.600"
      _light={{ bg: 'gray.50' }}
      borderRadius={12}
      alignItems="center"
      pos="relative"
      justifyContent="space-between"
      animation={fadeInScaleAnimation()}
      border="1px solid"
      borderColor="transparent"
      transition="background-color 200ms ease"
      {...getStyle(ensureEnumNumber(JobState, job.state))}
    >
      <Flex flexDir="column" alignItems="start">
        <Text fontSize="11px" fontWeight="bold" color="gray.300">
          {dateFromNow(Locale.En, job.created)}
        </Text>
        <Text fontWeight="bold">{translation.title}</Text>
        <Text color="gray.100" _light={{ color: 'gray.800' }}>
          {job.latestMessage}
        </Text>
      </Flex>
      {compareEnum(JobState, job.state, JobState.Running) && <Spinner />}
    </Flex>
  );
}

function getStyle(state: JobState): FlexProps | null {
  switch (state) {
    case JobState.Waiting:
    case JobState.Running:
      return { bg: 'hsl(0 100 100 / 0.02)', borderColor: 'gray.600' };
    case JobState.Finished:
    case JobState.Failed:
    case JobState.Cancelled:
      return null;
  }
}
